import styled from 'styled-components'
import { calculateResponsiveSize } from 'helpers/calculateResponsiveSize'
import { mediaMax } from 'helpers/mediaQueries'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Subtitle = styled.h4`
  margin-bottom: ${calculateResponsiveSize(12)};
  font-family: 'proxima_nova_semibold', san-serif;
  /* font-weight: 600; */
  font-size: ${calculateResponsiveSize(18)};
  letter-spacing: ${calculateResponsiveSize(1.8)};
  color: ${({ $color }) => ($color === 'white' ? `#fff;` : '#1E1E1E;')};

  ${mediaMax('desktopSm')} {
    font-size: 18px;
    margin-bottom: 9px;
  }
  ${mediaMax('tabletLandscape')} {
    margin-bottom: 15px;
    font-size: 14px;
    letter-spacing: 1.4px;
    color: ${({ $mobileColor }) =>
      $mobileColor === 'dark' ? `#1E1E1E;` : '#fff;'};
  }
`

export const Title = styled.h3`
  font-weight: 400;
  line-height: 1.2;
  white-space: pre-wrap;
  color: ${({ $color }) => ($color === 'white' ? `#fff;` : '#1E1E1E;')};
  ${({ $size }) => {
    switch ($size) {
      case 'smallWithLargeMargin':
        return `
          font-size: ${calculateResponsiveSize(48)};
          margin-bottom: ${calculateResponsiveSize(60)};
        `
      case 'largeWithSmallMargin':
        return `
          font-size: ${calculateResponsiveSize(60)};
          margin-bottom: ${calculateResponsiveSize(24)};
        `
      case 'small':
        return `
          font-size: ${calculateResponsiveSize(48)};
          margin-bottom: ${calculateResponsiveSize(24)};
        `
      case 'largeWithMiddleMargin':
        return `
          font-size: ${calculateResponsiveSize(60)};
          margin-bottom: ${calculateResponsiveSize(48)};
        `
      default:
        return `
          font-size: ${calculateResponsiveSize(60)};
          margin-bottom: ${calculateResponsiveSize(60)};
        `
    }
  }}
  ${mediaMax('desktopSm')} {
    font-size: 36px;
    margin-bottom: 24px;
    line-height: 42px;
    letter-spacing: -0.72px;
    white-space: initial;
  }
  ${mediaMax('tablet')} {
    margin-left: ${({ $mobileMargin }) => ($mobileMargin ? `-44px` : '0')};
    color: ${({ $mobileColor }) =>
      $mobileColor === 'dark' ? `#1E1E1E;` : '#fff;'};
  }
`

export const Description = styled.p`
  font-weight: 400;
  font-size: ${calculateResponsiveSize(21)};
  line-height: ${({ $lineHeight }) => ($lineHeight === 'lg' ? 2 : 1.66)};
  color: ${({ $color }) => ($color === 'white' ? `#fff;` : '#1E1E1E;')};
  width: ${({ $width }) => ($width ? $width : '')};
  align-self: ${({ $align }) => ($align ? $align : '')};
  ${mediaMax('desktopSm')} {
    font-size: 18px;
    line-height: 1.6;
  }

  ${mediaMax('tabletLandscape')} {
    width: 100%;
    color: ${({ $mobileColor }) =>
      $mobileColor === 'dark' ? `#1E1E1E;` : '#fff;'};
    padding-left: ${({ $mobileDescriptionPadding }) =>
      $mobileDescriptionPadding ? `44px` : '0'};
  }
`
